// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_179fbf', '__Inter_Fallback_179fbf'","fontStyle":"normal"},"className":"__className_179fbf"};